module.exports = {"id":"194171","name":"Knowledge Musona","rating":"72","photo":"./data/images/photos/4/194171.png","club":{"name":"KV Ostende","logo":"./data/images/clubs/KVOstende.png"},"positions":["BU","MG","MOC","MD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KnowledgeMusona0.json
// module id = 2392
// module chunks = 0